// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":global(table.ExcelTable span.ant-calendar-picker) {\n    width: 127px !important;\n}\n:global(table.ExcelTable .ant-select-selection.ant-select-selection--single) {\n    border: none !important;\n    outline: none;\n}\n\n:global(.ant-comment) {\n    padding: 20px;\n    margin: 25px 0px;\n    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.12);\n    width: 95%;\n    margin: 0 auto;\n    margin-top: 25px;\n    margin-bottom: 25px;\n    border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
